import * as angular from "angular";
import {IController, IScope} from "angular";

export class FulfillmentStepItemComponent implements IController {

  fulfillmentId: string;
  fulfillment: any;
  stepId: string;
  stepNumber: any;
  index: number;
  relations: any;
  isOpen: boolean;
  isMatchFilter: boolean;
  selectedKeys: any;
  excludeMode: boolean;
  isShowCheckbox: boolean;
  stepPriceInfo: any;
  onDispatch: Function;
  onSplit: Function;
  onAutoAssign: Function;
  onAssignRoute: Function;
  onAssignAgent: Function;
  onCancelService: Function;
  onCancelAttempt: Function;
  onToggleViewStep: Function;
  onToggleSelect: Function;
  onAddNote: Function;
  onCreateRoute: Function;
  onAssignResourceAllocation: Function;
  onCompleteManually: Function;
  onReset: Function;

  public step: any;
  public showMoreInfo: boolean;

  constructor(private $fulfillmentStep, private $scope: IScope) {
  }

  $onInit() {
    if (this.stepId) {
      this.$fulfillmentStep(this.stepId).$bindCtrlToId(this.$scope, this, 'step', 'stepId', {fulfillmentId: this.fulfillmentId});
    }
  }

  $onChanges(changes) {
    if (changes.stepId && !changes.stepId.isFirstChange() || changes.fulfillmentId && !changes.fulfillmentId.isFirstChange()) {
      this.$onInit();
    }
  }

  getStepNumberByIndex(id) {
    return parseInt(id.at(-1)) + 1;
  }

  onToggleSelectStep() {
    this.onToggleSelect({step: this.step})
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentStepItem', {
    bindings: {
      fulfillmentId: '<',
      fulfillment: '<',
      stepId: '<',
      stepNumber: '<',
      isSelected: '<',
      onToggleSelect: '&',
      onDispatch: '&',
      onSplit: '&',
      onAutoAssign: '&',
      onAssignAgent: '&',
      onAssignResourceAllocation: '&',
      onAssignRoute: '&',
      onCancelService: '&',
      onCancelAttempt: '&',
      onAddNote: '&',
      onCreateRoute: '&',
      onCompleteManually: '&',
      onReset: '&'
    },
    template: require('./fulfillment-step-item.html').default,
    controller: FulfillmentStepItemComponent
  });
